import '../style/poi-description.scss'

const POIDescription = ({ description }) => (
    <div className="poi-description" dangerouslySetInnerHTML={{ __html: description }} />
)

export default POIDescription
